export enum WeatherCode {
  ClearSky = 0,
  MainlyClear = 1,
  PartlyCloudy = 2,
  Overcast = 3,
  Fog = 45,
  DepositingRimeFog = 48,
  LightDrizzle = 51,
  ModerateDrizzle = 53,
  DenseDrizzle = 55,
  LightFreezingDrizzle = 56,
  ModerateOrDenseFreezingDrizzle = 57,
  LightRain = 61,
  ModerateRain = 63,
  HeavyRain = 65,
  LightFreezingRain = 66,
  ModerateOrHeavyFreezingRain = 67,
  SlightSnowfall = 71,
  ModerateSnowfall = 73,
  HeavySnowfall = 75,
  SnowGrains = 77,
  SlightRainShowers = 80,
  ModerateRainShowers = 81,
  HeavyRainShowers = 82,
  SlightSnowShowers = 85,
  HeavySnowShowers = 86,
  ThunderstormSlightOrModerate = 95,
  ThunderstormStrong = 96,
  ThunderstormHeavy = 99
}
// Mapping WeatherCode enum values to icon names
export const weatherIconMap: { [key in WeatherCode]: string } = {
  [WeatherCode.ClearSky]: "sunny",
  [WeatherCode.MainlyClear]: "sunny",
  [WeatherCode.PartlyCloudy]: "cloudy",
  [WeatherCode.Overcast]: "cloud",
  [WeatherCode.Fog]: "foggy",
  [WeatherCode.DepositingRimeFog]: "cloud",
  [WeatherCode.LightDrizzle]: "rain",
  [WeatherCode.ModerateDrizzle]: "rain",
  [WeatherCode.DenseDrizzle]: "rain",
  [WeatherCode.LightFreezingDrizzle]: "snow",
  [WeatherCode.ModerateOrDenseFreezingDrizzle]: "snow",
  [WeatherCode.LightRain]: "rain",
  [WeatherCode.ModerateRain]: "rain",
  [WeatherCode.HeavyRain]: "strong-rain",
  [WeatherCode.LightFreezingRain]: "snow-rain",
  [WeatherCode.ModerateOrHeavyFreezingRain]: "snow-rain",
  [WeatherCode.SlightSnowfall]: "snow",
  [WeatherCode.ModerateSnowfall]: "snow",
  [WeatherCode.HeavySnowfall]: "snow",
  [WeatherCode.SnowGrains]: "snow",
  [WeatherCode.SlightRainShowers]: "rain",
  [WeatherCode.ModerateRainShowers]: "rain",
  [WeatherCode.HeavyRainShowers]: "strong-rain",
  [WeatherCode.SlightSnowShowers]: "snow",
  [WeatherCode.HeavySnowShowers]: "snow",
  [WeatherCode.ThunderstormSlightOrModerate]: "storm",
  [WeatherCode.ThunderstormStrong]: "storm",
  [WeatherCode.ThunderstormHeavy]: "storm"
};
